import { StrapiID } from '@ca/common/types'
import FrameSettingsContent, {
  FrameSettingsPage,
} from '@screens/frame/settings/FrameSettingsContent'
import useBundleType from '@order/hooks/useBundleType'
import { useOrderState } from '@order/hooks/useOrderState'
import { trpc } from 'api'
import { Redirect } from 'expo-router'
import { useMemo } from 'react'

export default function FrameSettings({ frameId }: { frameId: StrapiID }) {
  const orderItems = useOrderState((s) => s.order.items)
  const orderItem = orderItems.find(
    (i) => i.frame?.id?.toString() === frameId?.toString()
  )

  const frameQuery = trpc.frames.customer.byId.useQuery(
    { frameId },
    {
      enabled: !orderItem?.frame,
      initialData: orderItem?.frame ?? undefined,
    }
  )

  const { bundleType } = useBundleType()

  const frame = orderItem?.frame ?? frameQuery.data

  const selectHref = useMemo(() => {
    return {
      pathname: `/frame/select`,
      params: { bundleType },
    }
  }, [bundleType])

  if (frameQuery.isPending) {
    return <FrameSettingsPage />
  }
  if (frameQuery.isError) {
    return <Redirect href={selectHref} />
  }

  if (!frame) {
    return <Redirect href={selectHref} />
  }

  return <FrameSettingsContent frame={frame} />
}
